import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useBootstrapAuth } from '../hooks/useAuth.js';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useBootstrapAuth();

  if (status === 'unknown') {
    return (
      <div className="splash">
        <span>Loading…</span>
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
